export const unitsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_UNIT_LIST_REQUEST":
      return { ...state, loading: true, units: null };
    case "GET_UNIT_LIST_SUCCESS":
      return { ...state, loading: false, units: action.payload };
    case "GET_UNIT_LIST_FAILED":
      return { ...state, loading: false, units: action.payload };
    case "ADD_UNIT_REQUEST":
      return { ...state, loading: true, units: null };
    case "ADD_UNIT_SUCCESS":
      return { ...state, loading: false, units: action.payload };
    case "ADD_UNIT_FAILED":
      return { ...state, loading: false, units: action.payload };
    case "EDIT_UNIT_REQUEST":
      return { ...state, loading: true, units: null };
    case "EDIT_UNIT_SUCCESS":
      return { ...state, loading: false, units: action.payload };
    case "EDIT_UNIT_FAILED":
      return { ...state, loading: false, units: action.payload };
    case "VIEW_UNIT_REQUEST":
      return { ...state, loading: true, unit: null };
    case "VIEW_UNIT_SUCCESS":
      return { ...state, loading: false, unit: action.payload };
    case "VIEW_UNIT_FAILED":
      return { ...state, loading: false, unit: action.payload };
    default:
      return state;
  }
};
